// baseUrl.ts

type Env = "local" | "prod";

// ⚠️ CHANGE THIS TO "prod" BEFORE YOU PUSH TO GITHUB
const ENV: Env = "prod"; 

// 1. Check the domain the user is currently visiting
const hostname = typeof window !== "undefined" ? window.location.hostname : "";
const isHackathon = hostname.includes("chaturvyuha") || hostname.includes("hackathon.localhost");

interface Urls {
  local: string;
  prod: string;  
}

// 2. Dynamically assign REST API URLs
export const BASE_URLS: Urls = {
  local: isHackathon 
    ? "http://localhost:3000/api/hackathon" 
    : "http://localhost:3000/api",
  prod: isHackathon 
    ? "https://api.chaturvyuha.app/api/hackathon" // Hackathon Backend
    : "https://api.codechatura.com/api",                      // Main Backend
};

// 3. Dynamically assign WebSocket URLs
export const WS_URLS: Urls = {
  local: "ws://localhost:3000",
  prod: isHackathon 
    ? "wss://api.chaturvyuha.app" // Hackathon Sockets
    : "wss://api.codechatura.com",            // Main Sockets
};

// Export the final URLs based on the ENV toggle
export const BASE_URL = BASE_URLS[ENV];
export const WS_URL = WS_URLS[ENV];